import dayjs from 'dayjs';
import { AxiosInstance } from '../../../utilities/requestClient';
import { AuditLogEntry } from './types';

export const fetchAuditLogData = async (
  startDate: Date,
  endDate: Date,
): Promise<AuditLogEntry[]> => {
  const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
  const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');

  const response = await AxiosInstance.get<AuditLogEntry[]>(
    'rs_audit_log/audit_log/get_audit_log/',
    {
      params: {
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      },
    },
  );

  const data = Array.isArray(response.data) ? response.data : [];

  return [...data].sort(
    (a, b) =>
      new Date(b.endpoint_execution_datetime).getTime() -
      new Date(a.endpoint_execution_datetime).getTime(),
  );
};
